import Auth from '../auth/Auth';
import { WebClient } from './WebClient'

class ApiBilling extends WebClient {

    async runMonthlyBilling(): Promise<boolean> {
        const url = `/billing/runmonthly`;

        return this.get(url, Auth.getAuthToken()).then(res => {
            return (res.status === 200);
        }).catch(() => { return false; });
    }
}

export default new ApiBilling();
